var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 12,
  viewBox: "0 0 17 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.5303 6.87005C16.8232 6.57716 16.8232 6.10228 16.5303 5.80939L11.7574 1.03642C11.4645 0.743527 10.9896 0.743527 10.6967 1.03642C10.4038 1.32931 10.4038 1.80419 10.6967 2.09708L14.9393 6.33972L10.6967 10.5824C10.4038 10.8753 10.4038 11.3501 10.6967 11.643C10.9896 11.9359 11.4645 11.9359 11.7574 11.643L16.5303 6.87005ZM0 7.08972H16V5.58972H0V7.08972Z",
  fill: "#8AB2FF"
})));
export default SvgIconArrow;